import React from 'react';
import { Dialog } from '../../../../../components/dialog';
import { DialogType } from '../../../../../components/dialog/dialog';
import { Typography } from '@mui/material';
import { useRemoveGatewayMutation } from '../../../../../app/store';
import { immediateToast } from 'utils/toast';
import { LoadingButton } from '@mui/lab';
import { useGatewayCardContext } from '../gateway-card.context';

const CancellationDialog: React.FC<Pick<DialogType, 'open' | 'onClose'>> = ({
    open,
    onClose,
}) => {
    const { gateway } = useGatewayCardContext();
    const [removeGateway, { isLoading }] = useRemoveGatewayMutation();

    const handleRemoveGateway = () => {
        removeGateway({ id: gateway.id })
            .unwrap()
            .then(() => {
                immediateToast('success', {
                    message: 'درخواست درگاه با موفقیت حذف شد',
                    timeout: 2000,
                });
                onClose && onClose();
            })
            .catch((err) => {
                immediateToast('error', {
                    message: err.message,
                    timeout: 2000,
                });
            });
    };

    return (
        <Dialog
            type="error"
            icon={<i className="fa-light fa-trash-can" />}
            open={open}
            onClose={onClose}
            width="370px"
            label="حذف درخواست درگاه"
        >
            <Typography
                sx={{
                    color: 'text.secondary',
                    fontSize: 13,
                    lineHeight: 2,
                    textAlign: 'center',
                    px: 0.5,
                }}
            >
                {`آیا از حذف درخواست درگاه پرداخت «${gateway?.title}» برای سایت ${gateway?.website} اطمینان دارید؟`}
            </Typography>

            <LoadingButton
                fullWidth
                loading={isLoading}
                sx={{
                    mt: 2.5,
                    minHeight: 40,
                    color: '#fff !important',
                    '&.Mui-disabled': {
                        color: 'rgba(255,255,255,.65) !important',
                    },
                }}
                variant="contained"
                color="error"
                onClick={handleRemoveGateway}
            >
                تایید و حذف درخواست
            </LoadingButton>
        </Dialog>
    );
};

export default CancellationDialog;
